/* MBS product card helpers (see snippets/mbs-product-card.liquid).
   1. <mbs-pc-media>: reads the edge pixels of the product photo once it loads and picks how it sits on the card:
      plain   - even light background: the frame gets a compensating tint so, with multiply, the photo background
                lands exactly on the card surface (no visible box); edges get a 2.5% feather.
      edge    - light background but the product touches the photo's edge: same tint, no feather (a feather would
                fade the product).
      clear   - transparent PNG: shown as is.
      photo   - busy or dark background (lifestyle shot): shown as a rounded framed photo, never cropped.
      Results are cached per image for the session. Works for cards added later (filters, infinite scroll).
   2. Announces "Added to cart" for screen readers when the theme marks a quick-add button as successful.
   3. Buy Now loading state, and focus return when the theme's Quick View (Choose Options) closes.
   4. <mbs-cart-protection>: the opt-in shipping protection switch in the cart. */
(function () {
  if (window.customElements && !customElements.get('mbs-pc-media')) {
    var SURFACE = 235;
    var KEY = 'mbs-pc-tone2:';

    var read = function (k) { try { return JSON.parse(sessionStorage.getItem(KEY + k)); } catch (e) { return null; } };
    var write = function (k, v) { try { sessionStorage.setItem(KEY + k, JSON.stringify(v)); } catch (e) {} };

    var analyse = function (img) {
      var n = 48, c = document.createElement('canvas');
      c.width = c.height = n;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data;
      var minA = 255, px = [];
      var take = function (x0, y0) {
        var i = (y0 * n + x0) * 4;
        minA = Math.min(minA, d[i + 3]);
        px.push([d[i], d[i + 1], d[i + 2], 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]]);
      };
      for (var k = 1; k < n - 1; k++) { take(k, 1); take(k, n - 2); take(1, k); take(n - 2, k); }
      if (minA < 245) return { t: 'clear' };
      var light = px.filter(function (p) { return p[3] >= 225 && Math.max(p[0], p[1], p[2]) - Math.min(p[0], p[1], p[2]) <= 14; });
      if (light.length / px.length < 0.6) return { t: 'photo' };
      var lums = light.map(function (p) { return p[3]; }).sort(function (a, b) { return a - b; });
      var lo = lums[Math.floor(lums.length * 0.03)], hi = lums[Math.floor(lums.length * 0.97)];
      if (hi - lo > 18) return { t: 'photo' };
      var mean = [0, 1, 2].map(function (c) { return light.reduce(function (a, p) { return a + p[c]; }, 0) / light.length; });
      var comp = mean.map(function (e) { return Math.min(255, Math.round(SURFACE * 255 / Math.max(e, 1))); });
      return { t: light.length === px.length ? 'plain' : 'edge', c: comp };
    };

    customElements.define('mbs-pc-media', class extends HTMLElement {
      connectedCallback() {
        var img = this.querySelector('img');
        if (!img) { this.dataset.tone = 'none'; return; }
        var key = (img.getAttribute('src') || '').split('?')[0];
        var cached = key && read(key);
        if (cached) { this.apply(cached); return; }
        var run = () => {
          if (!img.naturalWidth) return;
          var r;
          try { r = analyse(img); } catch (e) { return; } // cross-origin image: keep the default multiply blend
          write(key, r);
          this.apply(r);
        };
        if (img.complete) run(); else img.addEventListener('load', run, { once: true });
      }
      apply(r) {
        this.dataset.tone = r.t;
        var frame = this.querySelector('.mbs-pc__frame');
        if (frame && (r.t === 'plain' || r.t === 'edge') && r.c) frame.style.setProperty('--pc-comp', 'rgb(' + r.c.join(',') + ')');
      }
    });
  }

  // Screen-reader confirmation for quick add (the theme adds .is-success after a successful add)
  var watch = function (root) {
    (root || document).querySelectorAll('.mbs-pc [data-add-to-cart]:not([data-pc-watch])').forEach(function (btn) {
      btn.setAttribute('data-pc-watch', '');
      var status = btn.closest('form') && btn.closest('form').querySelector('[data-pc-status]');
      if (!status || !window.MutationObserver) return;
      new MutationObserver(function () {
        if (btn.classList.contains('is-success')) {
          var t = btn.closest('.mbs-pc').querySelector('.mbs-pc__link');
          status.textContent = 'Added to cart' + (t ? ': ' + t.textContent.trim() : '');
          setTimeout(function () { status.textContent = ''; }, 4000);
        }
      }).observe(btn, { attributes: true, attributeFilter: ['class'] });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); }); else watch();

  // Buy Now: show the spinner while the browser posts to the cart and moves to checkout; block double clicks.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-pc-buynow]')) return;
    var btn = f.querySelector('button');
    if (btn) { btn.classList.add('is-loading'); setTimeout(function () { btn.disabled = true; }, 0); }
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-pc-buynow] button').forEach(function (b) { b.classList.remove('is-loading'); b.disabled = false; });
  });

  // Opt-in shipping protection in the cart (snippets/mbs-cart-protection.liquid)
  if (window.customElements && !customElements.get('mbs-cart-protection')) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var post = function (path, body) {
      return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    };
    var getCart = function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); };
    var refresh = function () { document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); };
    customElements.define('mbs-cart-protection', class extends HTMLElement {
      connectedCallback() {
        this.vid = Number(this.dataset.variantId);
        this.input = this.querySelector('[data-protect-toggle]');
        this.msg = this.querySelector('[data-protect-msg]');
        if (!this.input) return;
        this.input.addEventListener('change', () => this.set(this.input.checked));
        // Keep the switch in step with the cart (items removed elsewhere, drawer reopened, other tabs)
        var target = this.closest('form') || document.body, t;
        this.mo = new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => this.sync(), 300); });
        this.mo.observe(target, { childList: true, subtree: true });
        this.sync();
      }
      disconnectedCallback() { if (this.mo) this.mo.disconnect(); }
      say(t) { if (this.msg) { this.msg.textContent = t; clearTimeout(this.st); this.st = setTimeout(() => { this.msg.textContent = ''; }, 4000); } }
      set(on) {
        if (this.busy) return;
        this.busy = true; this.input.disabled = true; this.classList.add('is-busy');
        getCart().then((cart) => {
          var line = cart.items.find((i) => i.variant_id === this.vid);
          if (on && !line) return post('cart/add.js', { items: [{ id: this.vid, quantity: 1 }] });
          if (on && line && line.quantity !== 1) return post('cart/change.js', { id: line.key, quantity: 1 });
          if (!on && line) return post('cart/change.js', { id: line.key, quantity: 0 });
        }).then(() => {
          this.say(on ? 'Shipping protection added' : 'Shipping protection removed');
          refresh();
        }).catch(() => {
          this.input.checked = !on;
          this.say('Could not update shipping protection. Please try again.');
        }).then(() => { this.busy = false; this.input.disabled = false; this.classList.remove('is-busy'); });
      }
      sync() {
        if (this.busy) return;
        getCart().then((cart) => {
          var line = cart.items.find((i) => i.variant_id === this.vid);
          var others = cart.items.filter((i) => i.variant_id !== this.vid).length;
          // Protection on its own makes no sense: drop it when the last real item leaves the cart
          if (line && others === 0) { this.busy = true; return post('cart/change.js', { id: line.key, quantity: 0 }).then(() => { this.busy = false; this.input.checked = false; refresh(); }); }
          this.input.checked = !!line;
        }).catch(function () {});
      }
    });
  }

  // Quick View focus return: the theme closes its Quick View (Escape, close button, backdrop) without moving focus
  // back. Remember which card button opened it and return focus there when it closes.
  var qvTrigger = null;
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.mbs-pc [data-button-quick-view]');
    if (t) qvTrigger = t;
  }, true);
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && document.activeElement && document.activeElement.matches && document.activeElement.matches('.mbs-pc [data-button-quick-view]')) qvTrigger = document.activeElement;
  }, true);
  if (window.MutationObserver) {
    var wasOpen = false;
    new MutationObserver(function () {
      var open = document.body.classList.contains('js-quick-view-visible');
      if (wasOpen && !open && qvTrigger && document.contains(qvTrigger)) {
        var a = document.activeElement;
        if (!a || a === document.body || (a.closest && a.closest('.pswp, .popup-quick-view'))) {
          var t = qvTrigger;
          setTimeout(function () { t.focus({ preventScroll: true }); }, 50);
        }
      }
      wasOpen = open;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; watch(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
